import {
  FETCH_ADDRESSESS_REQUEST,
  FETCH_ADDRESSESS_SUCCESS,
  FETCH_ADDRESSESS_FAIL,
  CREATE_PROPERTY_REQUEST,
  CREATE_PROPERTY_SUCCESS,
  CREATE_PROPERTY_FAIL,
  GET_ALL_LISTING_REQUEST,
  GET_ALL_LISTING_SUCCESS,
  GET_ALL_LISTING_FAIL,
  GET_SINGLE_PROPERTY_REQUEST,
  GET_SINGLE_PROPERTY_FAIL,
  GET_SINGLE_PROPERTY_SUCCESS,
  INVITE_TENANTS_REQUEST,
  INVITE_TENANTS_FAIL,
  INVITE_TENANTS_SUCCESS,
  SEND_CREATE_ACCOUNT_REMINDER_REQUEST,
  SEND_CREATE_ACCOUNT_REMINDER_FAIL,
  SEND_CREATE_ACCOUNT_REMINDER_SUCCESS,
  DELETE_TENANTS_FROM_PROPERTY_SUCCESS,
  DELETE_TENANTS_FROM_PROPERTY_REQUEST,
  DELETE_TENANTS_FROM_PROPERTY_FAIL,
  UPDATE_TENANCY_PERIOD_REQUEST,
  UPDATE_TENANCY_PERIOD_SUCCESS,
  UPDATE_TENANCY_PERIOD_FAIL,
  UPDATE_PROPERTY_DETAILS_REQUEST,
  UPDATE_PROPERTY_DETAILS_SUCCESS,
  UPDATE_PROPERTY_DETAILS_FAIL,
  DELETE_BEDROOM_REQUEST,
  DELETE_BEDROOM_SUCCESS,
  DELETE_BEDROOM_FAIL,
  ADD_BEDROOMS_REQUEST,
  ADD_BEDROOMS_SUCCESS,
  ADD_BEDROOMS_FAIL,
  UPDATE_BEDROOM_IDENTIFIER_REQUEST,
  UPDATE_BEDROOM_IDENTIFIER_SUCCESS,
  UPDATE_BEDROOM_IDENTIFIER_FAIL,
  UPDATE_TENANT_EMAIL_SUCCESS,
  UPDATE_TENANT_EMAIL_FAIL,
  UPDATE_TENANT_EMAIL_REQUEST,
  SET_PROPERTY_LISTING_PAGE_SIZE,
  GET_LISTINGS_PREFETCH_SUCCESS,
  GET_LISTINGS_STATS_REQUEST,
  GET_LISTINGS_STATS_SUCCESS,
  GET_LISTINGS_STATS_FAIL,
  INVALIDATE_LISTINGS_STATS_CACHE,
  GET_LISTING_DOCUMENTS_REQUEST,
  GET_LISTING_DOCUMENTS_SUCCESS,
  GET_LISTING_DOCUMENTS_FAIL,
  UPLOAD_LISTING_DOCUMENT_REQUEST,
  UPLOAD_LISTING_DOCUMENT_SUCCESS,
  UPLOAD_LISTING_DOCUMENT_FAIL,
  DELETE_LISTING_DOCUMENT_SUCCESS,
  DELETE_LISTING_DOCUMENT_FAIL,
  SET_LISTING_DOCUMENT_SHARE_SUCCESS,
  SET_LISTING_DOCUMENT_SHARE_FAIL,
  RENAME_LISTING_DOCUMENT_SUCCESS,
  RENAME_LISTING_DOCUMENT_FAIL
} from "./propertyTypes";

const PROPERTY_LISTING_DEFAULT_PAGE_SIZE = 25;

const initialState = {
  loading: false,
  addressess: [],
  listings: [],
  success: false,
  singleProperty: null,
  overallActiveTenants: 0,
  overallActiveAssignedTeants: 0,
  propertyListingPageSize: PROPERTY_LISTING_DEFAULT_PAGE_SIZE,
  listingsPage: 0,
  listingsTotal: 0,
  listingsSearchTerm: "",
  nextPageListings: null,
  nextPagePage: null,
  statsLoading: false,
  statsLastFetched: null,
  documents: [],
  documentsLoading: false,
  documentUploading: false
};

const propertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADDRESSESS_REQUEST:
    case CREATE_PROPERTY_REQUEST:
    case GET_SINGLE_PROPERTY_REQUEST:
    case INVITE_TENANTS_REQUEST:
    case SEND_CREATE_ACCOUNT_REMINDER_REQUEST:
    case DELETE_TENANTS_FROM_PROPERTY_REQUEST:
    case UPDATE_TENANCY_PERIOD_REQUEST:
    case UPDATE_TENANT_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        addressess: []
      };
    case GET_ALL_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        address: [],
        listings: []
        // Preserve stats - don't reset them on listing request
        // Stats are managed separately via GET_LISTINGS_STATS_SUCCESS
      };
    case DELETE_BEDROOM_REQUEST:
    case UPDATE_PROPERTY_DETAILS_REQUEST:
    case ADD_BEDROOMS_REQUEST:
    case UPDATE_BEDROOM_IDENTIFIER_REQUEST:
      return {
        ...state,
        loading: true,
        success: false
      };
    case FETCH_ADDRESSESS_SUCCESS:
      return {
        ...state,
        addressess: action.payload,
        loading: false
      };
    case CREATE_PROPERTY_SUCCESS:
      return {
        ...state,
        listings: [...state.listings, action.payload],
        loading: false,
        success: true
      };
    case CREATE_PROPERTY_FAIL:
      return {
        ...state,
        listings: state.listings,
        loading: false,
        success: false
      };
    case GET_ALL_LISTING_SUCCESS: {
      const payload = action.payload;
      const isPaginated = payload.total !== undefined;
      return {
        ...state,
        listings: payload.listings || [],
        // Don't update stats from listing response - stats are managed separately
        // Only update if explicitly provided (backward compatibility)
        ...(payload.overallActiveTenants !== undefined && {
          overallActiveTenants: payload.overallActiveTenants
        }),
        ...(payload.overallActiveAssignedTeants !== undefined && {
          overallActiveAssignedTeants: payload.overallActiveAssignedTeants
        }),
        ...(isPaginated && {
          listingsPage: payload.page ?? 0,
          listingsTotal: payload.total ?? 0
        }),
        ...(payload.searchTerm !== undefined && {
          listingsSearchTerm: payload.searchTerm
        }),
        loading: false,
        nextPageListings: null,
        nextPagePage: null
      };
    }
    case SET_PROPERTY_LISTING_PAGE_SIZE:
      return {
        ...state,
        propertyListingPageSize: action.payload
      };
    case GET_LISTINGS_PREFETCH_SUCCESS:
      return {
        ...state,
        nextPageListings: action.payload.listings,
        nextPagePage: action.payload.page
      };
    case GET_LISTINGS_STATS_REQUEST:
      return {
        ...state,
        statsLoading: true
      };
    case GET_LISTINGS_STATS_SUCCESS:
      return {
        ...state,
        overallActiveTenants: action.payload.overallActiveTenants ?? 0,
        overallActiveAssignedTeants: action.payload.overallActiveAssignedTeants ?? 0,
        statsLoading: false,
        statsLastFetched: Date.now()
      };
    case GET_LISTINGS_STATS_FAIL:
      return {
        ...state,
        statsLoading: false
      };
    case INVALIDATE_LISTINGS_STATS_CACHE:
      return {
        ...state,
        statsLastFetched: null // Invalidate cache - force refetch on next request
      };
    case GET_LISTING_DOCUMENTS_REQUEST:
      return {
        ...state,
        documentsLoading: true
      };
    case GET_LISTING_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: action.payload || [],
        documentsLoading: false
      };
    case GET_LISTING_DOCUMENTS_FAIL:
      return {
        ...state,
        documentsLoading: false
      };
    case UPLOAD_LISTING_DOCUMENT_REQUEST:
      return {
        ...state,
        documentUploading: true
      };
    case UPLOAD_LISTING_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: [action.payload, ...state.documents],
        documentUploading: false
      };
    case UPLOAD_LISTING_DOCUMENT_FAIL:
      return {
        ...state,
        documentUploading: false
      };
    case DELETE_LISTING_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: state.documents.filter((doc) => doc._id !== action.payload)
      };
    case DELETE_LISTING_DOCUMENT_FAIL:
      return state;
    // The server returns the updated document, so patch the row in place rather
    // than refetching the whole list for a boolean flip.
    case SET_LISTING_DOCUMENT_SHARE_SUCCESS:
      return {
        ...state,
        documents: state.documents.map((doc) =>
          doc._id === action.payload._id ? { ...doc, ...action.payload } : doc
        )
      };
    case SET_LISTING_DOCUMENT_SHARE_FAIL:
      return state;
    // The server returns the renamed document, so patch the row in place —
    // same pattern as SET_LISTING_DOCUMENT_SHARE_SUCCESS above.
    case RENAME_LISTING_DOCUMENT_SUCCESS:
      return {
        ...state,
        documents: state.documents.map((doc) =>
          doc._id === action.payload._id ? { ...doc, ...action.payload } : doc
        )
      };
    case RENAME_LISTING_DOCUMENT_FAIL:
      return state;
    case GET_SINGLE_PROPERTY_SUCCESS:
    case SEND_CREATE_ACCOUNT_REMINDER_SUCCESS:
    case DELETE_TENANTS_FROM_PROPERTY_SUCCESS:
    case INVITE_TENANTS_SUCCESS:
    case UPDATE_TENANCY_PERIOD_SUCCESS:
    case UPDATE_PROPERTY_DETAILS_SUCCESS:
    case DELETE_BEDROOM_SUCCESS:
    case ADD_BEDROOMS_SUCCESS:
    case UPDATE_BEDROOM_IDENTIFIER_SUCCESS:
    case UPDATE_TENANT_EMAIL_SUCCESS:
      return {
        ...state,
        singleProperty: action.payload,
        loading: false
      };
    case INVITE_TENANTS_FAIL:
      return {
        ...state,
        loading: false
      };
    case FETCH_ADDRESSESS_FAIL:
      return {
        ...state,
        loading: false
      };
    case GET_ALL_LISTING_FAIL:
      return {
        ...state,
        loading: false,
        success: false
        // Preserve stats on failure
      };
    case GET_SINGLE_PROPERTY_FAIL:
    case SEND_CREATE_ACCOUNT_REMINDER_FAIL:
    case DELETE_TENANTS_FROM_PROPERTY_FAIL:
    case UPDATE_TENANCY_PERIOD_FAIL:
    case UPDATE_TENANT_EMAIL_FAIL:
    case UPDATE_PROPERTY_DETAILS_FAIL:
    case DELETE_BEDROOM_FAIL:
    case ADD_BEDROOMS_FAIL:
    case UPDATE_BEDROOM_IDENTIFIER_FAIL:
      return {
        loading: false,
        success: false
      };

    default:
      return state;
  }
};

export default propertyReducer;
